import { RetailerWrapper } from "./styles";
import { Button } from "@/common/components/button";
import {
  financialManagementTableHeaders,
  financialManagementTableKeys,
  getFinancialManagementTableData,
  newFundRequestForm,
  retailerCards,
} from "./data";
import Table from "@/common/components/Table";
import { Pagination } from "@/common/components/pagination";
import { KeyValueObj } from "@/common/types";
import { useCallback, useMemo, useState } from "react";
import useQuery from "@/hooks/useQuery";
import { DELIVERY_REQUEST_URLS } from "@/common/constants";
import { Modal } from "@/common/components/modal";
import Form from "@/common/components/form/Form";
import { Prompt } from "@/common/components/prompt";
import { LargeCard } from "../stats/subs/LargeCard";

const Retailer = () => {
  const [currentRow, setCurrentRow] = useState<KeyValueObj>({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [financialPerpage, setFinancialPerpage] = useState(25);
  const [showViewModal, setShowViewModal] = useState(false);
  const [newRequestModal, setNewRequestModal] = useState(false);

  const {
    data: financialmanagement,
    meta: financialmanagementMeta,
    loading: financialLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${financialPerpage}&page=${financialPerpage}`
  );

  const handleDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showDropdown;
      const newRow = willShow ? row : {};

      setCurrentRow(newRow);
      setShowDropdown(willShow);
    },
    [showDropdown]
  );

  const handleFinancialView = useCallback(() => {
    alert("coming soon");
  }, []);

  const financialDropdowns = useMemo(
    () =>
      currentRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleFinancialView }]
        : [{ label: "View", action: handleFinancialView }],
    [handleFinancialView, currentRow]
  );

  const handleNewFundSubmit = () => {
    alert("Form submitted");
  };

  const inventoryStatus = () => {
    return currentRow?.userStatus?.value === "active";
  };

  return (
    <RetailerWrapper>
      <div className="card-wrapper">
        {retailerCards?.map((card: any) => (
          <LargeCard
            color={card?.color}
            icon={card.icon}
            value={card.value}
            title={card.name}
          />
        ))}
      </div>
      <div>
        <div className="top-wrapper">
          <Button onClick={() => setNewRequestModal(true)}>
            New Fund Request
          </Button>
        </div>
      </div>
      <div className="table-wrapper">
        <Table
          tableHeaders={financialManagementTableHeaders}
          tableKeys={financialManagementTableKeys}
          tableData={getFinancialManagementTableData(financialmanagement)}
          tableTitle="Fund allocation history"
          loading={financialLoading}
          handleDropDownClicked={handleDropdownClick}
          showDropDown={showDropdown}
          dropDownOptions={financialDropdowns}
          spaced
          rowLineColor="light"
        />
        <Pagination
          pageCount={financialmanagementMeta?.total_pages}
          onNextPage={(event: any) => setFinancialPerpage(event.selected)}
          onPerPageChange={(event: any) =>
            setFinancialPerpage(event?.target?.value)
          }
        />
      </div>
      <Modal
        title="New Fund Request"
        isOpen={newRequestModal}
        close={() => setNewRequestModal(false)}
      >
        <div className="modal">
          <Form
            formInputs={newFundRequestForm}
            processInputs={handleNewFundSubmit}
          />
        </div>
      </Modal>
      <Modal isOpen={showViewModal} close={() => setShowViewModal(false)}>
        <Prompt
          prompt={`Are you sure you want to ${
            inventoryStatus() ? "deactivate" : "activate"
          } user`}
          type={inventoryStatus() ? "delete" : "accept"}
          onMainAction={(_?: any) => {
            alert("coming soon");
          }}
          onSecondaryAction={() => setShowViewModal(false)}
        />
      </Modal>
    </RetailerWrapper>
  );
};

export default Retailer;
